module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-base-75.7ee1e66f.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-base-75.png
// module id = 2564
// module chunks = 11